/*
 * Animacion del boton "Add to cart" al comprar (GSAP).
 * Al enviar: se ocultan icono + texto y queda el loader girando.
 * Al terminar: vuelven a aparecer. El drawer lo abre el tema, no este script.
 *
 * Se engancha a la clase `loading` que product-form.js pone/saca del boton,
 * asi que no duplicamos la logica de carrito.
 */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUR = REDUCED ? 0 : 0.16;

  function parts(btn) {
    // El texto es el primer span hijo directo; el del spinner cuelga del div
    var text = null;
    for (var i = 0; i < btn.children.length; i++) {
      if (btn.children[i].tagName === 'SPAN') {
        text = btn.children[i];
        break;
      }
    }
    return {
      icon: btn.querySelector('.btn-cart-icon'),
      text: text,
      spinner: btn.querySelector('.loading__spinner, .loading-overlay__spinner'),
    };
  }

  function toLoading(btn) {
    if (btn.dataset.atcAnimating === 'in') return;
    btn.dataset.atcAnimating = 'in';

    var p = parts(btn);
    var out = [p.icon, p.text].filter(Boolean);
    if (typeof window.gsap === 'undefined') return;

    // Icono y texto salen hacia arriba
    if (out.length) {
      window.gsap.to(out, {
        opacity: 0,
        y: -14,
        duration: DUR,
        ease: 'power2.in',
        stagger: 0.03,
      });
    }

    // El loader entra desde abajo
    if (p.spinner) {
      window.gsap.fromTo(
        p.spinner,
        { opacity: 0, yPercent: 60 },
        {
          opacity: 1,
          yPercent: 0,
          duration: DUR,
          ease: 'power2.out',
          delay: DUR * 0.4,
        }
      );
    }
  }

  function toIdle(btn) {
    if (btn.dataset.atcAnimating === 'out') return;
    btn.dataset.atcAnimating = 'out';

    var p = parts(btn);
    var back = [p.icon, p.text].filter(Boolean);
    if (typeof window.gsap === 'undefined') return;

    // El loader se va hacia abajo
    if (p.spinner) {
      window.gsap.to(p.spinner, {
        opacity: 0,
        yPercent: 60,
        duration: DUR,
        ease: 'power2.in',
      });
    }

    // Icono y texto bajan de vuelta a su lugar
    if (back.length) {
      window.gsap.to(back, {
        opacity: 1,
        y: 0,
        duration: DUR,
        ease: 'power2.out',
        stagger: 0.03,
        delay: DUR * 0.4,
        clearProps: 'transform',
      });
    }
  }

  function watch(btn) {
    if (btn.dataset.atcWatched) return;
    btn.dataset.atcWatched = '1';

    // product-form.js alterna la clase `loading` en el boton
    var obs = new MutationObserver(function () {
      if (btn.classList.contains('loading')) toLoading(btn);
      else toIdle(btn);
    });
    obs.observe(btn, { attributes: true, attributeFilter: ['class'] });
  }

  /* Red de seguridad: si algo interrumpe la animacion (el drawer se abre
     encima, un error de red), el texto no puede quedar invisible. */
  function resetVisibility(btn) {
    var p = parts(btn);
    [p.icon, p.text].filter(Boolean).forEach(function (el) {
      el.style.opacity = '';
      el.style.transform = '';
    });
  }

  /*
   * product-form.js hace `this.querySelector('[type="submit"]')`, o sea que
   * solo encuentra el boton que vive DENTRO de <product-form>. El del sticky
   * queda afuera y nunca recibe `loading` ni se le muestra el spinner, aunque
   * envie el mismo form. Espejamos el estado del boton principal al sticky.
   */
  function mirrorToSticky() {
    var main = document.querySelector('product-form .product-form__submit');
    var sticky = document.querySelector('.sticky-atc .button[type="submit"]');
    if (!main || !sticky) return;

    // Solo anima el boton que el usuario apreto; el otro queda intacto.
    var clicked = null;
    [main, sticky].forEach(function (b) {
      b.addEventListener('click', function () {
        clicked = b;
      });
    });

    var failsafe;
    var obs = new MutationObserver(function () {
      var loading = main.classList.contains('loading');
      var target = clicked || main;

      // El estado visual va SOLO al boton clickeado
      if (target === sticky) {
        // product-form.js marca el principal: lo devolvemos a su estado normal
        main.classList.remove('loading');
        resetVisibility(main);
        var mainSp = main.querySelector('.loading__spinner, .loading-overlay__spinner');
        if (mainSp) mainSp.classList.add('hidden');

        sticky.classList.toggle('loading', loading);
        var sp = sticky.querySelector('.loading__spinner, .loading-overlay__spinner');
        if (sp) sp.classList.toggle('hidden', !loading);
      }

      if (loading) target.setAttribute('aria-disabled', 'true');
      else target.removeAttribute('aria-disabled');

      clearTimeout(failsafe);
      if (loading) {
        // Si el estado `loading` no se limpia (drawer encima, error), no
        // dejamos los botones vacios para siempre.
        failsafe = setTimeout(function () {
          [main, sticky].forEach(function (b) {
            b.classList.remove('loading');
            resetVisibility(b);
            var s = b.querySelector('.loading__spinner, .loading-overlay__spinner');
            if (s) s.classList.add('hidden');
          });
        }, 6000);
      } else {
        [main, sticky].forEach(resetVisibility);
        clicked = null;
      }
    });
    obs.observe(main, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    if (typeof window.gsap === 'undefined') return;
    document
      .querySelectorAll('.product-form__submit, .sticky-atc .button')
      .forEach(watch);
    mirrorToSticky();
  }

  function boot() {
    if (typeof window.gsap !== 'undefined') init();
    else window.addEventListener('load', init, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
